import hexToRgba from './hexToRgba';

export const getSoCChartData = (socStart: number, socStop: number) => {
  let startColor = '#405fb9';
  let stopColor = '#86002d';

  if (socStart >= 60) startColor = '#405fb9';
  else if (socStart >= 30 && socStart < 60) startColor = '#ccbb00';
  else if (socStart < 30) startColor = '#86002d';

  if (socStop >= 60) stopColor = '#405fb9';
  else if (socStop >= 30 && socStop < 60) stopColor = '#ccbb00';
  else if (socStop < 30) stopColor = '#86002d';

  if (socStart > socStop) {
    if (startColor === stopColor) startColor = hexToRgba(stopColor, 0.5);
    const chartData = [
      {
        name: 'SoC Final',
        value: socStop,
        color: startColor,
      },
      {
        name: 'SoC Inicial',
        value: socStart - socStop,
        color: stopColor,
      },
      {
        name: 'SoC Restante',
        value: 100 - socStart,
        color: '#FFFFFF',
      },
    ];
    return { chartData, startColor, stopColor };
  } else if (socStart < socStop) {
    if (startColor === stopColor) stopColor = hexToRgba(startColor, 0.5);
    const chartData = [
      {
        name: 'SoC Inicial',
        value: socStart,
        color: startColor,
      },
      {
        name: 'SoC Final',
        value: socStop - socStart,
        color: stopColor,
      },
      {
        name: 'SoC Restante',
        value: 100 - socStop,
        color: '#FFFFFF',
      },
    ];
    return { chartData, startColor, stopColor };
  } else {
    const chartData = [
      {
        name: 'SoC Final',
        value: socStop,
        color: stopColor,
      },
      {
        name: 'SoC Inicial',
        value: socStart - socStop,
        color: startColor,
      },
      {
        name: 'SoC Restante',
        value: 100 - socStart,
        color: '#FFFFFF',
      },
    ];
    return { chartData, startColor, stopColor };
  }
};
